import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/contacts',
    name: 'ContactsPage',
    component: () => import('@/modules/contacts/views/ContactsPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/contacts/create',
    name: 'ContactsCreatePage',
    component: () => import('@/modules/contacts/views/ContactsFormPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/contacts/edit/:id',
    name: 'ContactsEditPage',
    component: () => import('@/modules/contacts/views/ContactsFormPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
